import { render, staticRenderFns } from "./DistrictSetting.vue?vue&type=template&id=11223d3c&scoped=true"
import script from "./DistrictSetting.vue?vue&type=script&lang=js"
export * from "./DistrictSetting.vue?vue&type=script&lang=js"
import style0 from "./DistrictSetting.vue?vue&type=style&index=0&id=11223d3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11223d3c",
  null
  
)

export default component.exports